import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_SIGNATURE_RECEIPT_EMAIL_PROMOTION_COUNT = defineFcm(
	'promoted_signature_receipt_email_promotion_count',
)
	.asNumber()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description:
			'Defines the number of promoted petitions that should be included in the footer of the signature receipt email',
	});
